// Fetches runtime app config (AdMob ids, Razorpay key, flags) once and caches it.
const BACKEND = process.env.REACT_APP_BACKEND_URL;
let _cache = null;
let _inflight = null;

export function getAppConfig() {
  if (_cache) return Promise.resolve(_cache);
  if (_inflight) return _inflight;
  _inflight = fetch(`${BACKEND}/api/app/config`)
    .then((r) => r.json())
    .then((cfg) => { _cache = cfg; _inflight = null; return cfg; })
    .catch(() => { _inflight = null; return null; });
  return _inflight;
}
